<script setup lang="ts">
import type { Rules } from "async-validator";
import type { UserDetails } from "~/modules/user/models/UserDetails.interface";

const { t, locale } = useI18n();
const props = defineProps<{
  user?: UserDetails;
}>();

const emit = defineEmits(["saveLanguage"]);

const formRules: Rules = {
  language: [
    {
      required: true,
    },
  ],
};

const languageForm = reactive({
  language: props.user?.language,
});

const onClick = () => {
  emit("saveLanguage", {
    language: languageForm.language,
  });
};
</script>

<template>
  <container-component :px="0" :py="0">
    <h2>{{ t("user.userAccount.language.title") }}</h2>

    <span>
      {{ t("user.userAccount.instructions.language") }}
    </span>

    <lxc-form ref="userLanguageForm" :rules="formRules" :model="languageForm">
      <lxc-form-item class="max-w-64 pt-2" prop="language">
        <language-component v-model="languageForm.language" />
      </lxc-form-item>
      <lxc-button
        type="primary"
        html-type="button"
        :title="t('user.userAccount.forms.validate')"
        :disabled="!languageForm.language || languageForm.language === locale"
        @click="onClick"
      >
        {{ t("user.userAccount.forms.validate") }}
      </lxc-button>
    </lxc-form>
  </container-component>
</template>
